if (!customElements.get("td-atc-button")) {
    class TDAtcButton extends HTMLElement {
        constructor() {
            super();
            this.BUTTON_CLASS = '.td-atc';
            this.BUTTON_TEXT_CLASS = '.td-cs-atc--text';
            this.BUTTON_LOADING_CLASS = '.td-atc-loading';
            this.BUTTON_CHECKMARK_CLASS = '.td-atc-checkmark';
            this.BUTTON_HIDE_CLASS = 'td-atc--hide';
            this.BUTTON_ANIMATE_CLASS = 'td-atc--fade-out';

            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.buttonText = this.querySelector(this.BUTTON_TEXT_CLASS);
            this.buttonCheckmark = this.querySelector(this.BUTTON_CHECKMARK_CLASS);
            this.buttonLoader = this.querySelector(this.BUTTON_LOADING_CLASS);
            this.mainButton = this.querySelector(this.BUTTON_CLASS);
        }
    
        connectedCallback() {
            this.listenerController = new AbortController();
            if (this.mainButton) {
                this.mainButton.addEventListener('click', () => {
                    this.mainButton.disabled = true;
                    var productID = this.mainButton.dataset.productId
                    this.buttonText.classList.add(this.BUTTON_HIDE_CLASS)
                    this.buttonLoader.classList.remove(this.BUTTON_HIDE_CLASS)
                    this.addItemToCart([{ id: productID, quantity: 1}])
                }, { signal: this.listenerController.signal })
            }
        }

        disconnectedCallback() {
            this.listenerController.abort();
            clearTimeout(this.checkmarkTimeout);
        }

        async addItemToCart(product) {
            try {
                const renderedSections = this.cart?.getSectionsToRender?.().map((section) => section.id) || [];
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                    },
                    body: JSON.stringify({
                        items: product,
                        sections: renderedSections
                    }),
                    credentials: "same-origin",
                });
        
                const data = await response.json();
                if (this.cart?.renderContents) {
                    this.cart.renderContents(data);
                    this.cart.classList.remove('is-empty');
                } else {
                    document.documentElement.dispatchEvent(
                        new CustomEvent('cart:refresh', {
                            bubbles: true,
                        })
                    );
                }
        
                this.animateCheckmark();
                this.mainButton.disabled = false;
            } catch (err) {
                console.error(err);
                this.buttonLoader.classList.add(this.BUTTON_HIDE_CLASS)
                this.buttonText.classList.remove(this.BUTTON_HIDE_CLASS)
                this.buttonText.textContent = "Error"
                this.mainButton.disabled = false;

            }
        }

        animateCheckmark() {
            this.buttonLoader.classList.add(this.BUTTON_HIDE_CLASS)
            this.buttonCheckmark.classList.remove(this.BUTTON_HIDE_CLASS)
            this.buttonCheckmark.classList.add(this.BUTTON_ANIMATE_CLASS)
            this.checkmarkTimeout = setTimeout(() => {
                this.buttonCheckmark.classList.add(this.BUTTON_HIDE_CLASS)
                this.buttonText.classList.remove(this.BUTTON_HIDE_CLASS)
            }, 700);
        }
    }

    customElements.define("td-atc-button", TDAtcButton);
}
